function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4b4b4b;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Lager_2",
  "data-name": "Lager 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "_\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M164.8,86h-2.62a1.8,1.8,0,0,1-1.34-.6,1.79,1.79,0,0,1-.44-1.4,17.12,17.12,0,0,0,.12-2,17.66,17.66,0,1,0-35.32,0,17.42,17.42,0,0,0,.12,2,1.78,1.78,0,0,1-.44,1.39,1.8,1.8,0,0,1-1.34.6h-70a1.79,1.79,0,0,1-1.77-2,19.92,19.92,0,0,0,.11-2,17.66,17.66,0,1,0-35.31,0,19.92,19.92,0,0,0,.11,2,1.78,1.78,0,0,1-.44,1.39,1.8,1.8,0,0,1-1.34.6H12.42A12.43,12.43,0,0,1,0,73.57V59.27A19.83,19.83,0,0,1,8.76,42.8l5-3.38a1.76,1.76,0,0,1,1-.3H123.41a1,1,0,0,1,.25,0l39.83,5.64a16,16,0,0,1,13.72,15.8v13A12.43,12.43,0,0,1,164.8,86Zm-.71-3.59h.71a8.84,8.84,0,0,0,8.83-8.83v-13A12.43,12.43,0,0,0,163,48.32l-39.7-5.62h-108l-4.55,3.07a16.26,16.26,0,0,0-7.18,13.5v14.3a8.85,8.85,0,0,0,8.84,8.83H13V82a21.24,21.24,0,1,1,42.47,0v.4h66.18c0-.13,0-.27,0-.4a21.24,21.24,0,1,1,42.48,0C164.1,82.13,164.1,82.27,164.09,82.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M34.21,103.24A21.24,21.24,0,1,1,55.45,82,21.26,21.26,0,0,1,34.21,103.24Zm0-38.9A17.66,17.66,0,1,0,51.87,82,17.67,17.67,0,0,0,34.21,64.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M142.86,103.24A21.24,21.24,0,1,1,164.1,82,21.27,21.27,0,0,1,142.86,103.24Zm0-38.9A17.66,17.66,0,1,0,160.52,82,17.68,17.68,0,0,0,142.86,64.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M123.41,42.7H14.77a1.79,1.79,0,0,1-1.55-.89,1.81,1.81,0,0,1,0-1.79l14-24.61A30.55,30.55,0,0,1,53.74,0H84.45A30.55,30.55,0,0,1,111,15.41L125,40a1.79,1.79,0,0,1-1.56,2.68ZM17.85,39.12H120.33L107.84,17.18A27,27,0,0,0,84.45,3.58H53.74a27,27,0,0,0-23.4,13.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M69.09,42.7a1.79,1.79,0,0,1-1.79-1.79V1.79a1.79,1.79,0,1,1,3.58,0V40.91A1.79,1.79,0,0,1,69.09,42.7Z"
})));

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 177.21 103.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.2cd749b2.svg";
export { ForwardRef as ReactComponent };